/* tslint:disable */
import {
  Fee,
  ChartOfAccount,
  IncomeInvoice
} from '../index';

declare var Object: any;
export interface TenantFeeInterface {
  "amount": number;
  "lease_id": number;
  "fee_type_id": number;
  "chart_of_account_id"?: number;
  "income_invoice_id": number;
  "status": string;
  "recurrent"?: boolean;
  "id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  feeType?: Fee;
  chartOfAccount?: ChartOfAccount;
  incomeInvoice?: IncomeInvoice;
}

export class TenantFee implements TenantFeeInterface {
  "amount": number;
  "lease_id": number;
  "fee_type_id": number;
  "chart_of_account_id": number;
  "income_invoice_id": number;
  "status": string;
  "recurrent": boolean;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  feeType: Fee;
  chartOfAccount: ChartOfAccount;
  incomeInvoice: IncomeInvoice;
  constructor(data?: TenantFeeInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `TenantFee`.
   */
  public static getModelName() {
    return "TenantFee";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of TenantFee for dynamic purposes.
  **/
  public static factory(data: TenantFeeInterface): TenantFee{
    return new TenantFee(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'TenantFee',
      plural: 'TenantFees',
      path: 'TenantFees',
      idName: 'id',
      properties: {
        "amount": {
          name: 'amount',
          type: 'number'
        },
        "lease_id": {
          name: 'lease_id',
          type: 'number'
        },
        "fee_type_id": {
          name: 'fee_type_id',
          type: 'number'
        },
        "chart_of_account_id": {
          name: 'chart_of_account_id',
          type: 'number'
        },
        "income_invoice_id": {
          name: 'income_invoice_id',
          type: 'number'
        },
        "status": {
          name: 'status',
          type: 'string',
          default: 'ACTIVE'
        },
        "recurrent": {
          name: 'recurrent',
          type: 'boolean',
          default: false
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
        feeType: {
          name: 'feeType',
          type: 'Fee',
          model: 'Fee',
          relationType: 'belongsTo',
                  keyFrom: 'fee_type_id',
          keyTo: 'id'
        },
        chartOfAccount: {
          name: 'chartOfAccount',
          type: 'ChartOfAccount',
          model: 'ChartOfAccount',
          relationType: 'belongsTo',
                  keyFrom: 'chart_of_account_id',
          keyTo: 'id'
        },
        incomeInvoice: {
          name: 'incomeInvoice',
          type: 'IncomeInvoice',
          model: 'IncomeInvoice',
          relationType: 'belongsTo',
                  keyFrom: 'income_invoice_id',
          keyTo: 'id'
        },
      }
    }
  }
}
